import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MembershipForm = () => {
  const locationWarnedRef = useRef(false); // ✅ synchronous guard to prevent duplicate toasts

  const [formData, setFormData] = useState({
    fullName: "",
    sharma: "",
    dob: "",
    motherTongue: "",
    janmaMasam: "",
    rasi: "",
    vedam: "",
    gothram: "",
    nakshatram: "",
    kuladeivam: "",
    nativePlace: "",
    sootram: "",
    sootramOther: "",
    fathersName: "",
    mothersName: "",
    fathersOccupation: "",
    noOfChildren: "",
    children: [],
    mothersOccupation: "",
    noOfBrothers: "",
    noOfSisters: "",
    education: "",
    occupation: "",
    address: "",
    phone: "",
    email: "",
    read: "",
    write: "",
    speak: "",
    pursue: "",
    anyInfo: "",
    place: "",
    date: "",
    admin_id: "",
    latitude: "",
    longitude: "",
    timestamp: "",
    filledby: "",
    filledfor: "",
  });

  const initialState = {
    fullName: "",
    sharma: "",
    dob: "",
    motherTongue: "",
    janmaMasam: "",
    rasi: "",
    vedam: "",
    gothram: "",
    nakshatram: "",
    kuladeivam: "",
    nativePlace: "",
    sootram: "",
    sootramOther: "",
    fathersName: "",
    mothersName: "",
    fathersOccupation: "",
    mothersOccupation: "",
    noOfChildren: "",
    children: [],
    noOfBrothers: "",
    noOfSisters: "",
    education: "",
    occupation: "",
    address: "",
    phone: "",
    email: "",
    read: "",
    write: "",
    speak: "",
    pursue: "",
    anyInfo: "",
    place: "",
    date: "",
    admin_id: "",
    latitude: "",
    longitude: "",
    timestamp: "",
    filledby: "",
    filledfor: "",
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const admin_id = params.get("user_id") || "";
    const latitude = params.get("lat") || "";
    const longitude = params.get("lon") || "";
    const timestamp = params.get("time") || new Date().toISOString();
    const filledby = params.get("filledby") || "";
    const filledfor = params.get("filledfor") || "";

    setFormData((prev) => ({
      ...prev,
      admin_id,
      latitude,
      longitude,
      timestamp,
      filledby,
      filledfor,
    }));
  }, []);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [locationPermissionWarned, setLocationPermissionWarned] =
    useState(false);
  const FullScreenLoader = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100px" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50px"
          height="50px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke="#3498db"
            strokeWidth="10"
            r="35"
            strokeDasharray="164.93361431346415 56.97787143782138"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              repeatCount="indefinite"
              dur="1s"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
            />
          </circle>
        </svg>
      </div>
    </div>
  );

  useEffect(() => {
    // Auto-fill today's date
    const today = new Date().toISOString().split("T")[0];
    setFormData((prev) => ({ ...prev, date: today }));

    // Try to auto-fetch location on load
    // fetchLocation();
  }, []);

  // const fetchLocation = async () => {
  //   if (!navigator.geolocation) {
  //     toast.warn("Geolocation not supported by your browser.");
  //     return;
  //   }

  //   // Optional: check permission state first (if supported) to provide user guidance
  //   try {
  //     if (navigator.permissions && navigator.permissions.query) {
  //       try {
  //         const perm = await navigator.permissions.query({
  //           name: "geolocation",
  //         });
  //         if (perm.state === "denied") {
  //           if (!locationWarnedRef.current) {
  //             toast.info(
  //               "Location permission is blocked. To auto-fill Place, enable location in your browser settings."
  //             );
  //             locationWarnedRef.current = true; // ✅ immediate, prevents double toasts
  //           }
  //           return; // skip getCurrentPosition
  //         }
  //       } catch (permErr) {
  //         // ignore permission query errors
  //       }
  //     }

  //     navigator.geolocation.getCurrentPosition(
  //       async (position) => {
  //         const { latitude, longitude } = position.coords;
  //         try {
  //           // Reverse geocode using Nominatim (English results)
  //           // Note: Nominatim enforces rate limits — use responsibly in production.
  //           const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&accept-language=en`;
  //           const res = await fetch(url, {
  //             headers: {
  //               // supply a user-agent or referer in production if required by your usage policy
  //               "User-Agent": "MembershipForm/1.0 (your.email@example.com)",
  //             },
  //           });
  //           if (!res.ok)
  //             throw new Error("Reverse geocode failed: " + res.status);
  //           const data = await res.json();
  //           const address = data.address || {};

  //           const road =
  //             address.road ||
  //             address.pedestrian ||
  //             address.cycleway ||
  //             address.residential ||
  //             "";
  //           const area =
  //             address.suburb ||
  //             address.neighbourhood ||
  //             address.village ||
  //             address.locality ||
  //             "";
  //           const town = address.town || "";
  //           const city =
  //             address.city || address.county || address.district || "";
  //           const state = address.state || "";

  //           // Build parts and dedupe
  //           const parts = [road, area, town, city, state].filter(
  //             (v, i, self) => v && self.indexOf(v) === i
  //           );
  //           const placeName = parts.join(", ");

  //           setFormData((prev) => ({
  //             ...prev,
  //             place: placeName || prev.place,
  //             latitude,
  //             longitude,
  //           }));
  //         } catch (err) {
  //           console.error("Reverse geocode error:", err);
  //           toast.warn("Could not resolve address from coordinates.");
  //           // still set lat/long
  //           setFormData((prev) => ({
  //             ...prev,
  //             latitude,
  //             longitude,
  //           }));
  //         }
  //       },
  //       (error) => {
  //         console.warn("Geolocation error:", error);
  //         if (error.code === error.PERMISSION_DENIED) {
  //           toast.info(
  //             "Location permission denied. Click the Place field to try again."
  //           );
  //         } else {
  //           toast.warn("Unable to get your location.");
  //         }
  //       },
  //       { enableHighAccuracy: false, timeout: 10000, maximumAge: 5 * 60 * 1000 }
  //     );
  //   } catch (e) {
  //     console.error("fetchLocation error:", e);
  //     toast.warn("Error while trying to get location.");
  //   }
  // };
  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Required fields validation
    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
      isValid = false;
    }
    if (!formData.dob) {
      newErrors.dob = "Date of Birth is required";
      isValid = false;
    } else {
      const today = new Date();
      const dobDate = new Date(formData.dob);

      if (dobDate > today) {
        newErrors.dob = "Date of Birth cannot be in the future";
        isValid = false;
      }
      if (!formData.motherTongue.trim()) {
        newErrors.motherTongue = "Mother Tongue is required";
        isValid = false;
      }
      if (!formData.janmaMasam) {
        newErrors.janmaMasam = "Janma Masam is required";
        isValid = false;
      }
      if (!formData.rasi) {
        newErrors.rasi = "Rasi is required";
        isValid = false;
      }
      if (!formData.vedam) {
        newErrors.vedam = "Vedam is required";
        isValid = false;
      }
      if (!formData.gothram.trim()) {
        newErrors.gothram = "Gothram is required";
        isValid = false;
      }
      if (!formData.nakshatram.trim()) {
        newErrors.nakshatram = "Nakshatram is required";
        isValid = false;
      }
      if (!formData.kuladeivam.trim()) {
        newErrors.kuladeivam = "Kuladeivam is required";
        isValid = false;
      }
      if (!formData.nativePlace.trim()) {
        newErrors.nativePlace = "Native Place is required";
        isValid = false;
      }
      if (!formData.sootram) {
        newErrors.sootram = "Sootram is required";
        isValid = false;
      }
      if (formData.sootram === "Any Other" && !formData.sootramOther.trim()) {
        newErrors.sootramOther = "Please specify your Sootram";
        isValid = false;
      }
      if (!formData.fathersName.trim()) {
        newErrors.fathersName = "Father's Name is required";
        isValid = false;
      }
      if (!formData.mothersName.trim()) {
        newErrors.mothersName = "Mother's Name is required";
        isValid = false;
      }
      if (!formData.education.trim()) {
        newErrors.education = "Education is required";
        isValid = false;
      }
      if (!formData.occupation.trim()) {
        newErrors.occupation = "Occupation is required";
        isValid = false;
      }
      if (!formData.address.trim()) {
        newErrors.address = "Address is required";
        isValid = false;
      }
      if (!formData.phone.trim()) {
        newErrors.phone = "Phone is required";
        isValid = false;
      } else {
        const cleanedPhone = formData.phone.trim(); // remove leading/trailing spaces
        if (!/^\d{10,15}$/.test(cleanedPhone)) {
          newErrors.phone = "Please enter a valid phone number";
          isValid = false;
        } else {
          setFormData((prev) => ({ ...prev, phone: cleanedPhone }));
        }
      }

      if (formData.email.trim()) {
        // only validate if email is not empty
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
          newErrors.email = "Please enter a valid email address";
          isValid = false;
        }
      }
      if (!formData.place.trim()) {
        newErrors.place = "Place is required";
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fill all required fields correctly", {
        position: "top-center",
      });
      return;
    }

    setIsSubmitting(true);

    const finalData = {
      ...formData,
      sootram:
        formData.sootram === "Any Other"
          ? formData.sootramOther
          : formData.sootram,
    };

    fetch("http://induskitchens.com/submit.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(finalData),
    })
      .then((res) => res.json())
      .then((response) => {
        setIsSubmitting(false);
        if (response.status === "success") {
          toast.success("Form submitted successfully!", {
            position: "top-center",
          });
          setFormData({
            ...initialState,
            admin_id: formData.admin_id,
            latitude: formData.latitude,
            longitude: formData.longitude,
            timestamp: formData.timestamp,
            filledby: formData.filledby,
            filledfor: formData.filledfor,
          });
        } else {
          toast.error("Failed: " + response.message, {
            position: "top-center",
          });
        }
      })
      .catch((err) => {
        setIsSubmitting(false);
        toast.error("Error submitting form", {
          position: "top-center",
        });
        console.error(err);
      });
    console.log("Submitting data:", finalData);
  };

  return (
    <div className="container my-4">
      <ToastContainer />
      {isSubmitting && <FullScreenLoader />}
      <h4 className="text-center mb-4">
        VYAS-VIPRA YUVA ABHIVARDHAN SAMAJ MEMBERSHIP FORM
      </h4>
      <form onSubmit={handleSubmit}>
        {/* First Page Fields */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label>Full Name*</label>
            <input
              type="text"
              name="fullName"
              className={`form-control ${errors.fullName ? "is-invalid" : ""}`}
              onChange={handleChange}
              value={formData.fullName}
            />
            {errors.fullName && (
              <div className="invalid-feedback">{errors.fullName}</div>
            )}
          </div>
          <div className="col-md-6">
            <label>Sharma (for boys)</label>
            <input
              type="text"
              name="sharma"
              className="form-control"
              onChange={handleChange}
              value={formData.sharma}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Date of Birth*</label>
            <input
              type="date"
              name="dob"
              className={`form-control ${errors.dob ? "is-invalid" : ""}`}
              onChange={handleChange}
              value={formData.dob}
              max={new Date().toISOString().split("T")[0]} // Sets max date to today
            />
            {errors.dob && <div className="invalid-feedback">{errors.dob}</div>}
          </div>
          <div className="col-md-6">
            <label>Mother Tongue*</label>
            <input
              type="text"
              name="motherTongue"
              className={`form-control ${
                errors.motherTongue ? "is-invalid" : ""
              }`}
              onChange={handleChange}
              value={formData.motherTongue}
            />
            {errors.motherTongue && (
              <div className="invalid-feedback">{errors.motherTongue}</div>
            )}
          </div>
        </div>

        <div className="mb-3">
          <label>Janma Masam*</label>
          <select
            name="janmaMasam"
            className={`form-select ${errors.janmaMasam ? "is-invalid" : ""}`}
            onChange={handleChange}
            value={formData.janmaMasam}
          >
            <option value="">Select Janma Masam</option>
            <optgroup label="Souramanam">
              <option>Chithirai</option>
              <option>Vaikasi</option>
              <option>Aani</option>
              <option>Aadi</option>
              <option>Aavani</option>
              <option>purattasi</option>
              <option>Aippasi</option>
              <option>Karthigai</option>
              <option>Margazhi</option>
              <option>Thai</option>
              <option>Maasi</option>
              <option>Panguni</option>
            </optgroup>
            <optgroup label="Chandramanam">
              <option>Chaitra</option>
              <option>Vaishaka</option>
              <option>Jyeshta</option>
              <option>Aashaada</option>
              <option>Shraavana</option>
              <option>Bhaadrapada</option>
              <option>Aashvayuja</option>
              <option>Kaartika</option>
              <option>Maargashirsha</option>
              <option>Pousha</option>
              <option>Maagha</option>
              <option>Phaalguna</option>
            </optgroup>
          </select>
          {errors.janmaMasam && (
            <div className="invalid-feedback d-block">{errors.janmaMasam}</div>
          )}
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Rasi*</label>
            <select
              name="rasi"
              className={`form-select ${errors.rasi ? "is-invalid" : ""}`}
              onChange={handleChange}
              value={formData.rasi}
            >
              <option value="">Select Rasi</option>
              <option>Mesha</option>
              <option>Vrushaba</option>
              <option>Mithuna</option>
              <option>Kataka</option>
              <option>Simha</option>
              <option>Kanya</option>
              <option>Thulaa</option>
              <option>Vruschika</option>
              <option>Dhanush</option>
              <option>Makara</option>
              <option>Kumbha</option>
              <option>Meena</option>
            </select>
            {errors.rasi && (
              <div className="invalid-feedback d-block">{errors.rasi}</div>
            )}
          </div>
          <div className="col-md-6">
            <label>Vedam*</label>
            <select
              name="vedam"
              className={`form-select ${errors.vedam ? "is-invalid" : ""}`}
              onChange={handleChange}
              value={formData.vedam}
            >
              <option value="">Select Vedam</option>
              <option>Rig</option>
              <option>Yajurvedam</option>
              <option>Shuklayajur</option>
              <option> Saama (Kauthuma,Jaimini,Raanayaniya)</option>
              <option>Atharvana</option>
            </select>
            {errors.vedam && (
              <div className="invalid-feedback d-block">{errors.vedam}</div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Gothram*</label>
            <input
              type="text"
              name="gothram"
              className={`form-control ${errors.gothram ? "is-invalid" : ""}`}
              onChange={handleChange}
              value={formData.gothram}
            />
            {errors.gothram && (
              <div className="invalid-feedback">{errors.gothram}</div>
            )}
          </div>
          <div className="col-md-6">
            <label>Nakshatram (Birth Star)*</label>
            <input
              type="text"
              name="nakshatram"
              className={`form-control ${
                errors.nakshatram ? "is-invalid" : ""
              }`}
              onChange={handleChange}
              value={formData.nakshatram}
            />
            {errors.nakshatram && (
              <div className="invalid-feedback">{errors.nakshatram}</div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Kuladeivam / Sthala*</label>
            <input
              type="text"
              name="kuladeivam"
              className={`form-control ${
                errors.kuladeivam ? "is-invalid" : ""
              }`}
              onChange={handleChange}
              value={formData.kuladeivam}
            />
            {errors.kuladeivam && (
              <div className="invalid-feedback">{errors.kuladeivam}</div>
            )}
          </div>
          <div className="col-md-6">
            <label>Native Place*</label>
            <input
              type="text"
              name="nativePlace"
              className={`form-control ${
                errors.nativePlace ? "is-invalid" : ""
              }`}
              onChange={handleChange}
              value={formData.nativePlace}
            />
            {errors.nativePlace && (
              <div className="invalid-feedback">{errors.nativePlace}</div>
            )}
          </div>
        </div>

        <div className="mb-3">
          <label>Sootram*</label>
          <select
            name="sootram"
            className={`form-select ${errors.sootram ? "is-invalid" : ""}`}
            onChange={handleChange}
            value={formData.sootram}
          >
            <option value="">Select Sootram</option>
            <option>Aashvalaayana</option>
            <option>Apastamba</option>
            <option>Draahyaayana</option>
            <option>Bodaayana</option>
            <option>Bharadwaja</option>
            <option>Kaatyaayana</option>
            <option>Hiranyakeseeya</option>
            <option>Sathyaashaada</option>
            <option value="Any Other">Any Other</option>
          </select>
          {formData.sootram === "Any Other" && (
            <div className="mt-2">
              <input
                type="text"
                name="sootramOther"
                className={`form-control ${
                  errors.sootramOther ? "is-invalid" : ""
                }`}
                placeholder="Enter your Sootram"
                onChange={handleChange}
                value={formData.sootramOther}
              />
              {errors.sootramOther && (
                <div className="invalid-feedback">{errors.sootramOther}</div>
              )}
            </div>
          )}
          {errors.sootram && !formData.sootram && (
            <div className="invalid-feedback d-block">{errors.sootram}</div>
          )}
        </div>

        {/* Second Page Fields */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label>Father's Name*</label>
            <input
              type="text"
              name="fathersName"
              className={`form-control ${
                errors.fathersName ? "is-invalid" : ""
              }`}
              onChange={handleChange}
              value={formData.fathersName}
            />
            {errors.fathersName && (
              <div className="invalid-feedback">{errors.fathersName}</div>
            )}
          </div>
          <div className="col-md-6">
            <label>Mother's Name*</label>
            <input
              type="text"
              name="mothersName"
              className={`form-control ${
                errors.mothersName ? "is-invalid" : ""
              }`}
              onChange={handleChange}
              value={formData.mothersName}
            />
            {errors.mothersName && (
              <div className="invalid-feedback">{errors.mothersName}</div>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Father's Occupation & Designation</label>
            <input
              type="text"
              name="fathersOccupation"
              className="form-control"
              onChange={handleChange}
              value={formData.fathersOccupation}
            />
          </div>
          <div className="col-md-6">
            <label>Mother's Occupation & Designation</label>
            <input
              type="text"
              name="mothersOccupation"
              className="form-control"
              onChange={handleChange}
              value={formData.mothersOccupation}
            />
          </div>

          <div className="col-md-6">
            <label>No. of Children</label>
            <input
              type="number"
              min="0"
              name="noOfChildren"
              className="form-control"
              onChange={(e) => {
                const count = parseInt(e.target.value) || 0;
                setFormData((prev) => ({
                  ...prev,
                  noOfChildren: count,
                  children: Array.from(
                    { length: count },
                    (_, i) =>
                      prev.children?.[i] || { name: "", age: "", sex: "" }
                  ),
                }));
              }}
              value={formData.noOfChildren || ""}
            />
          </div>

          {/* Show child detail fields if user entered a number */}
          {formData.noOfChildren > 0 && (
            <div className="mb-3">
              <label>Children Details</label>
              {formData.children.map((child, index) => (
                <div key={index} className="row mb-2">
                  <div className="col-md-4">
                    <input
                      type="text"
                      placeholder="Name"
                      className="form-control"
                      value={child.name}
                      onChange={(e) => {
                        const updated = [...formData.children];
                        updated[index].name = e.target.value;
                        setFormData((prev) => ({ ...prev, children: updated }));
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      placeholder="Age"
                      className="form-control"
                      value={child.age}
                      onChange={(e) => {
                        const updated = [...formData.children];
                        updated[index].age = e.target.value;
                        setFormData((prev) => ({ ...prev, children: updated }));
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <select
                      className="form-select"
                      value={child.sex}
                      onChange={(e) => {
                        const updated = [...formData.children];
                        updated[index].sex = e.target.value;
                        setFormData((prev) => ({ ...prev, children: updated }));
                      }}
                    >
                      <option value="">Select Sex</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>No. of Brothers</label>
            <input
              type="number"
              min="0"
              name="noOfBrothers"
              className="form-control"
              onChange={handleChange}
              value={formData.noOfBrothers}
            />
          </div>
          <div className="col-md-6">
            <label>No. of Sisters</label>
            <input
              type="number"
              min="0"
              name="noOfSisters"
              className="form-control"
              onChange={handleChange}
              value={formData.noOfSisters}
            />
          </div>
        </div>

        <div className="mb-3">
          <label>Educational Qualification*</label>
          <input
            type="text"
            name="education"
            className={`form-control ${errors.education ? "is-invalid" : ""}`}
            onChange={handleChange}
            value={formData.education}
          />
          {errors.education && (
            <div className="invalid-feedback">{errors.education}</div>
          )}
        </div>

        <div className="mb-3">
          <label>Occupation & Designation*</label>
          <input
            type="text"
            name="occupation"
            className={`form-control ${errors.occupation ? "is-invalid" : ""}`}
            onChange={handleChange}
            value={formData.occupation}
          />
          {errors.occupation && (
            <div className="invalid-feedback">{errors.occupation}</div>
          )}
        </div>

        <div className="mb-3">
          <label>Address*</label>
          <textarea
            name="address"
            className={`form-control ${errors.address ? "is-invalid" : ""}`}
            onChange={handleChange}
            value={formData.address}
          ></textarea>
          {errors.address && (
            <div className="invalid-feedback">{errors.address}</div>
          )}
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Phone No.*</label>
            <input
              type="text"
              name="phone"
              className={`form-control ${errors.phone ? "is-invalid" : ""}`}
              onChange={handleChange}
              value={formData.phone}
            />
            {errors.phone && (
              <div className="invalid-feedback">{errors.phone}</div>
            )}
          </div>
          <div className="col-md-6">
            <label>E.mail</label>
            <input
              type="email"
              name="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              onChange={handleChange}
              value={formData.email}
            />
            {errors.email && (
              <div className="invalid-feedback">{errors.email}</div>
            )}
          </div>
        </div>

        <div className="mb-3">
          <label>Languages Known</label>
          <input
            type="text"
            name="read"
            placeholder="To Read"
            className="form-control mb-2"
            onChange={handleChange}
            value={formData.read}
          />
          <input
            type="text"
            name="write"
            placeholder="To Write"
            className="form-control mb-2"
            onChange={handleChange}
            value={formData.write}
          />
          <input
            type="text"
            name="speak"
            placeholder="To Speak"
            className="form-control"
            onChange={handleChange}
            value={formData.speak}
          />
        </div>

        <div className="mb-3">
          <label>Would like to pursue any of the following</label>
          <select
            name="pursue"
            className="form-select"
            onChange={handleChange}
            value={formData.pursue}
          >
            <option value="">Select an option</option>
            <option>Music (Vocal or Instrumental)</option>
            <option>Vedam (only boys)</option>
            <option>Shlokam</option>
          </select>
        </div>

        <div className="mb-3">
          <label>Any other information you wish to furnish</label>
          <textarea
            name="anyInfo"
            className="form-control"
            onChange={handleChange}
            value={formData.anyInfo}
          ></textarea>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Place*</label>
            <input
              type="text"
              name="place"
              className={`form-control ${errors.place ? "is-invalid" : ""}`}
              onChange={handleChange}
              value={formData.place}
            />
            {errors.place && (
              <div className="invalid-feedback">{errors.place}</div>
            )}
          </div>
          <div className="col-md-6">
            <label>Date*</label>
            <input
              type="date"
              name="date"
              className={`form-control ${errors.date ? "is-invalid" : ""}`}
              onChange={handleChange}
              value={formData.date}
            />
            {errors.date && (
              <div className="invalid-feedback">{errors.date}</div>
            )}
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-success w-100 d-flex justify-content-center align-items-center"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span className="ms-2">Submitting...</span>
            </>
          ) : (
            "Submit"
          )}
        </button>
      </form>
    </div>
  );
};

export default MembershipForm;
